import React from 'react';

import { Container, Typography } from '@mui/material';

const NotAuthorized: React.FC = () => {
  return (
    <Container>
      <Typography variant="h4" component="h1" align="center">
        403 - Acesso não autorizado
      </Typography>
    </Container>
  );
};

export default NotAuthorized;
